/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Styles from "./orderErrorModal.module.scss";
import { formatPriceWithoutSymbol } from "@/app/csr-src/utils/priceUtils";
import { useStores } from "@/app/csr-src/models";
import JDIPrice from "@/common-components-src/js/price/index";
import UKImg from "@/common-components-src/components/UKImg";
import UKDialog from "@/common-components-src/components/UKDialog/index";
import { EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25281";

interface OrderErrorProps {
  // outStockList: any[];
  open: boolean;
  // onClose: (params: any) => void;
  onlyClose: () => void;
  // title: string;
  // btnText: string;
}

const OrderError = (props: OrderErrorProps) => {
  const { checkoutStore } = useStores();

  const { outStockList, onClose, title, btnText } = checkoutStore.orderErrorMsg as any;
  console.log(outStockList, "outStockList");

  return (
    <UKDialog
      open={props.open}
      className={Styles.orderErrorPage}
      showCloseBtn={true}
      onClose={() => {
        props.onlyClose();
      }}
      sx={{
        "& .MuiDialog-paper": {
          width: "720px", // 设置自定义宽度
          maxWidth: "none", // 取消最大宽度限制
          maxHeight: "428px",
        },
      }}
    >
      <DialogTitle className={Styles.orderErrorTitle}>{title}</DialogTitle>
      <DialogContent>
        <div className={Styles.orderItemBox}
          exptag={"exp|" + EXPOSURE_RECORD.SettleAccounts_OrderNew_UnstockExpo}
          data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
          data-exptag-json-param={
            JSON.stringify({
              skuid: outStockList.map(((sku: any) => sku.skuId)),
            })
          }
        >
          {outStockList.map((sku: any, index: number) => {
            return (
              <div className={Styles.productItem} key={index}>
                {/* sku Image */}
                <div className={Styles.imageBox}>
                  <UKImg
                    urlExtend={{
                      imgKey: sku.imgUrl,
                      width: 120,
                      height: 120,
                    }}
                  />
                </div>
                <div className={Styles.basicInfo}>
                  <div className={Styles.productName}>
                    {/* discount */}
                    {sku.unitPromoDiscount && (
                      <span className={Styles.discountTag}>{sku.unitPromoDiscount}</span>
                    )}
                    {/* skuName */}
                    <span className={Styles.skuName} title={sku.skuName}>
                      {sku.skuName}
                    </span>
                  </div>
                  {/* product Spec */}
                  <div className={Styles.productSpec}>
                    {sku.attrList ? sku.attrList.join(" / ") : null}
                  </div>
                </div>
                <div className={Styles.priceBox}>
                  {/* price */}
                  {/* price */}
                  <JDIPrice
                    symbol={checkoutStore.currencySymbol}
                    price={sku.deliveryPrice}
                    uiType={1}
                    containerStyle={{
                      fontSize: "12px",
                      lineHeight: "16px",
                    }}
                    integerStyle={{
                      fontSize: "18px",
                      lineHeight: "24px",
                      height: "24px",
                    }}
                  />
                  {sku.deliveryPrice !== sku.price && (
                    <span className={Styles.skuPrice}>
                      <JDIPrice
                        symbol={checkoutStore.currencySymbol}
                        price={sku.price}
                        uiType={2}
                        containerStyle={{
                          fontSize: "12px",
                          lineHeight: "16px",
                          color: "#888B94",
                        }}
                        lineThrough
                      />
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </DialogContent>
      <DialogActions className={Styles.orderErrorFooter}>
        <Button
          onClick={() => {
            sendClickTrack.SettleAccounts_OrderNew_Unstock();
            onClose();
           }}
          color="primary"
          className={Styles.button}
          size="small"
          variant="outlined"
        >
          {btnText}
        </Button>
      </DialogActions>
    </UKDialog>
  );
};

export default OrderError;
